/**
 * *Employee Count Table Types & Empty States
 */
import { CountFrequency } from '../FinancialForensics.types';

export type FormatType = 'count' | 'subscription' | 'plan';

export interface TimeSeriesEntry {
  dateRange: string;
  value: number | null;
}

export interface BaseEntry {
  sourceOfData: string;
  typeOfCount: CountFrequency;
  values: TimeSeriesEntry[];
  fileURLs: string[];
}

export interface BreakdownItem {
  label: string;
  values: TimeSeriesEntry[];
}

export interface BreakdownEntry {
  sourceOfData: string;
  typeOfCount: CountFrequency;
  breakdown: BreakdownItem[];
  fileURLs: string[];
}

export interface EmployeeCount {
  employees: BaseEntry;
  members: BaseEntry;
  membersBySubscriptionType: BreakdownEntry;
  employeeBySubscriptionType: BreakdownEntry;
  employeeByPlanType: BreakdownEntry;
  memberByPlanType: BreakdownEntry;
}

const emptyBaseEntry = (): BaseEntry => ({
  sourceOfData: '',
  typeOfCount: 'Monthly',
  values: [],
  fileURLs: [],
});

const emptyBreakdownEntry = (): BreakdownEntry => ({
  sourceOfData: '',
  typeOfCount: 'Monthly',
  breakdown: [],
  fileURLs: [],
});

export const getEmptyEmployeeCount = (): EmployeeCount => ({
  employees: emptyBaseEntry(),
  members: emptyBaseEntry(),
  membersBySubscriptionType: emptyBreakdownEntry(),
  employeeBySubscriptionType: emptyBreakdownEntry(),
  employeeByPlanType: emptyBreakdownEntry(),
  memberByPlanType: emptyBreakdownEntry(),
});

export interface ModalDetail {
  type: string;
  values: TimeSeriesEntry[];
}

export interface EmployeeCountModalProps {
  id: string;
  source: string;
  detailsType: CountFrequency | undefined;
  details: ModalDetail[];
}

export const fromBaseEntry = (
  label: string,
  entry?: BaseEntry,
): ModalDetail => ({
  type: label,
  values: entry?.values ?? [],
});

export const fromBreakdownEntry = (entry?: BreakdownEntry): ModalDetail[] =>
  entry?.breakdown.map((item) => ({
    type: item.label,
    values: item.values,
  })) ?? [];

export const emptyEmployeeCountModalData = (): EmployeeCountModalProps => ({
  id: '',
  source: '',
  detailsType: undefined,
  details: [],
});
